<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a
        href="javascript:history.go(-1)"
        >{{ $t("anonymou_currpage") }}</a
      >
      <img src="../../assets/img/jt.gif" />{{ $t("document_sea_title") }}
    </div>

    <div>
      <table width="98%" cellpadding="0" cellspacing="0">
        <!--第一排-->
        <tr>
          <td width="25%" align="left">
            <b> {{ $t("normal_billtype") }}:</b> &nbsp;
            <select
              property="bill_type"
              value="${temp.bill_type}"
              v-model="addEntity.BillType"
            >
              <option value="M">M</option>
              <option value="D">D</option>
              <option value="H">H</option>
            </select>
          </td>
          <td width="25%" align="left">
            <b>{{ $t("inputno") }}:</b> &nbsp;

            <input
              type="text"
              name="master_no"
              value=""
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
              v-model="addEntity.HouseNo"
              :readonly="isReadonly"
            />
          </td>
          <td width="25%" align="left">
            <b>{{ $t("normal_mawb") }}:</b> &nbsp;
            <input
              type="text"
              name="master_no"
              value=""
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
              v-model="addEntity.MasterNo"
              style=""
            />
          </td>
          <td width="25%" align="left">
            <b>{{ $t("normal_billdate") }}:</b> &nbsp;
            <input
              type="text"
              name="bill_date"
              value=""
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
              v-model="addEntity.BillDate"
              style=""
            />
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td class="tr2" width="15%">{{ $t("normal_shprcode") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <select
                property="shpr_code"
                v-model="addEntity.ShprCode"
              ></select>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_shprename") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="shpr_ename"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
                v-model="addEntity.ShprEname"
                :readonly="isReadonly"
                size="40"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_shpradd") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="shpr_eaddr"
                size="90"
                v-model="addEntity.ShprEaddr"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
                style=""
              />
            </td>
          </tr>

          <tr class="tr3">
            <td class="tr4">{{ $t("normal_cneecode") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <select
                property="cnee_code"
                v-model="addEntity.CneeCode"
              ></select>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr4">{{ $t("normal_consignee") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="cnee_ename"
                size="40"
                v-model="addEntity.CneeEname"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr4">{{ $t("normal_cneeadd") }}:</td>
            <td valign="middle" align="left">
              &nbsp;
              <input
                type="text"
                name="cnee_eaddr"
                size="90"
                v-model="addEntity.CneeEaddr"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="50%" align="left">
            <b> {{ $t("vessel") }}/{{ $t("voyage") }}:</b> &nbsp;
            <input
              type="text"
              name="vessel"
              size="10"
              v-model="addEntity.Vessel"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            &nbsp;
            <input
              type="text"
              name="voyage"
              v-model="addEntity.Voyage"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
          <td width="50%" align="left">
            <b>{{ $t("Carrier") }}:</b> &nbsp;
            <input
              type="text"
              name="carr_code"
              size="10"
              v-model="addEntity.CarrCode"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
            &nbsp;
            <input
              type="text"
              name="carr_name"
              v-model="addEntity.CarrName"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td width="15%" height="18" valign="middle" class="tr2">
              {{ $t("normal_sea_closedate") }} :
            </td>
            <td width="25%" valign="middle">
              <input
                type="text"
                name="closing_date"
                v-model="addEntity.ClosingDate"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td width="15%" valign="middle">{{ $t("normal_sea_portre") }}</td>
            <td width="45%" valign="middle">
              <input
                type="text"
                name="por_code"
                v-model="addEntity.PorCode"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              &nbsp;
              <input
                type="text"
                name="por_code"
                v-model="addEntity.PorDescp"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2" valign="middle">{{ $t("normal_sea_etd") }}:</td>
            <td valign="middle">
              <input
                type="text"
                name="etd_date"
                v-model="addEntity.EtdDate"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td valign="middle">{{ $t("normal_sea_portl") }}:</td>
            <td valign="middle">
              <input
                type="text"
                name="pol_code"
                v-model="addEntity.PolCode"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              &nbsp;
              <input
                type="text"
                name="pol_descp"
                v-model="addEntity.PolDescp"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2" valign="middle">{{ $t("normal_sea_eta") }}:</td>
            <td valign="middle">
              <input
                type="text"
                name="eta_date"
                v-model="addEntity.EtaDate"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td valign="middle">{{ $t("normal_sea_portdh") }} :</td>
            <td valign="middle">
              <input
                type="text"
                name="pod_code"
                v-model="addEntity.PodCode"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              &nbsp;
              <input
                type="text"
                name="pod_descp"
                v-model="addEntity.PodDescp"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2" valign="middle">{{ $t("normal_sea_loading") }}</td>
            <td valign="middle">
              <input
                type="text"
                name="load_type1"
                v-model="addEntity.LoadType1"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              &nbsp;
              <input
                type="text"
                name="load_type2"
                v-model="addEntity.LoadType2"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td valign="middle">{{ $t("normal_sea_protdl") }}</td>
            <td valign="middle">
              <input
                type="text"
                name="pody_code"
                v-model="addEntity.PodyCode"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
              &nbsp;
              <input
                type="text"
                name="pody_descp"
                v-model="addEntity.PodyDescp"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="25%" align="left">
            <b>{{ $t("normal_pkg") }}:</b> &nbsp;
            <input
              type="text"
              name="qty"            
              v-model="addEntity.Qty"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
          <td width="25%" align="left">
            <b> {{ $t("normal_pkgde") }}:</b> &nbsp;
            <input
              type="text"
              name="qty_descp"
              v
              v-model="addEntity.QtyDescp"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
          <td width="50%">
            <b>{{ $t("normal_comm") }}:</b> &nbsp;
            <input
              type="text"
              name="cmdty_name"
              v-model="addEntity.CmdtyName"
              onmouseover="this.style.backgroundColor = '#FFFFE4'"
              onmouseout="this.style.backgroundColor = ''"
            />
          </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <!--DWLayoutTable-->
        <tbody>
          <tr class="tr3">
            <td width="15%" height="18" valign="middle" class="tr2">
              {{ $t("gw") }} :
            </td>
            <td width="18%" valign="middle">
              &nbsp;
              <input
                type="text"
                name="gw"
                v-model="addEntity.Gw"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td width="15%" valign="middle" class="tr2">
              {{ $t("normal_sea_cbm") }}:
            </td>
            <td width="18%" valign="middle">
              &nbsp;
              <input
                type="text"
                name="cbm"
                v-model="addEntity.Cbm"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td width="15%" valign="middle" class="tr2">
              {{ $t("normal_sea_cbf") }}:
            </td>
            <td width="19%" valign="middle">
              &nbsp;
              <input
                type="text"
                name="cuft"
                v-model="addEntity.Cuft"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td height="18" valign="middle" class="tr2">
              {{ $t("currency") }}:
            </td>
            <td valign="middle">
              &nbsp;
              <input
                type="text"
                name="crncy_code"
                v-model="addEntity.CrncyCode"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td valign="middle" class="tr2">{{ $t("freight") }}</td>
            <td valign="middle">
              &nbsp;
              <input
                type="text"
                name="frt_term"
                v-model="addEntity.FrtTerm"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
            <td valign="middle" class="tr2">{{ $t("other") }}</td>
            <td valign="middle">
              &nbsp;
              <input
                type="text"
                name="oth_term"
                v-model="addEntity.OthTerm"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
              />
            </td>
          </tr>
          <tr class="tr3">
            <td height="18" valign="middle" class="tr2">
              {{ $t("normal_marks") }}:
            </td>
            <td colspan="5" valign="middle" align="left">
              &nbsp;
              <textarea
                name="marks"
                rows="3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
                v-model="addEntity.Marks"
              ></textarea>
            </td>
          </tr>
          <tr class="tr3">
            <td class="tr2">{{ $t("normal_descp") }}:</td>
            <td colspan="5" valign="middle" align="left">
              &nbsp;
              <textarea
                name="goods_descp"
                rows="3"
                onmouseover="this.style.backgroundColor = '#FFFFE4'"
                onmouseout="this.style.backgroundColor = ''"
                v-model="addEntity.GoodsDescp"
              ></textarea>
            </td>
          </tr>
          <tr class="tr3">
            <td colspan="6" valign="middle" align="center">
              <input type="submit" :value="$t('submit')" @click="submitBL" />
              &nbsp;
              <input type="reset" :value="$t('reset')" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";

export default {
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      addEntity: {
        Qty:"",
        QtyDescp:"",
        CmdtyName:"",
        Gw:"",
        Cbm:"",
        Cuft:"",
        CrncyCode:"",
        FrtTerm:"",
        OthTerm:"",
        Marks:"",
        MasterNo: "",
        BillType: "",
        HouseNo: "",
        MasterNo: "",
        ShprCode: "",
        ShprEaddr: "",
        CneeEaddr: "",
        CneeEname: "",
        CneeCode: "",
        ShprEname: "",
        Vessel: "",
        Voyage: "",
        CarrCode:"",
        CarrName:"",
        ClosingDate:'',
        PodyDescp:"",
        PodyCode:"",
        LoadType2:"",
        LoadType1:"",
        PodDescp:"",
        PodCode:"",
        EtaDate:"",
        PolDescp:"",
        PolCode:"",
        EtdDate:"",
        PorDescp:"",
        PorCode:"",
        GoodsDescp:""
      },
      isReadonly: true,
    };
  },
  mounted: function () {
    // console.log(this.$route.path);
    //计算是否可读
    this.isReadonly = this.$route.path == "/add-awb-bl" ? false : true;
  },
  methods: {
   submitBL(){
// console.log("点击事件")
 }

  },
};
</script>
<style scoped>
body {
  font-size: 12px;
  color: #29384a;
}
input {
  border: 1px solid #009900;
}
td {
  word-break: break-all;
  word-wrap: break-word;
}
/* A:link {
	COLOR: #4455aa; TEXT-DECORATION: none
}

A:active {
	COLOR: #29384a; TEXT-DECORATION: none
}
A:visited {
	COLOR: #4455aa; TEXT-DECORATION: none
}
A:hover {
	COLOR: red; TEXT-DECORATION: underline
} */
A.showpage:link {
  color: #29384a;
  text-decoration: none;
}

A.showpage:active {
  color: #29384a;
  text-decoration: none;
}
A.showpage:visited {
  color: #29384a;
  text-decoration: none;
}
A.showpage:hover {
  color: #4455aa;
  text-decoration: underline;
}
.table_green {
  border: 1px solid #18b832;
  border-radius: 4px;
}
textarea {
  border: 1px solid #009900;
}
tableborder1 {
  border: 1px;
  width: 98%;
  background-color: #00ff00;
}

td.inText {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 150%;
  font-weight: bold;
  font-size: 16px;
}
.BoerderRight {
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #e7f3d6;
}
.BoerderLeft {
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #add76b;
}

.main_talbe {
  border: 1px solid white;
  background-color: #add76b;
  margin-top: 5px;
}
.main_talbe td {
  padding: 3px;
  border-bottom: solid 1px #e6e6e6;
  border-right: solid 1px #e6e6e6;
  min-height: 25px;
  line-height: 25px;
}
.main_talbe tbody tr td:first-child {
  border: solid 1px #e6e6e6;
}
.main_talbe tbody > tr:first-child > td {
  border-top: solid 1px #e6e6e6;
}
.tr1 {
  background-color: #ffffff;
  min-width: 120px;
}
.tr2 {
  background-color: #ffffff;
  min-width: 120px;
}
.tr3 {
  background-color: #ffffff;
  min-width: 120px;
}
.tr4 {
  background-color: #ffffff;
  min-width: 120px;
}
td.TopLighNav {
  background-image: url(../../assets/img//h1.gif);
}
td.TopLighNav1 {
  background-image: url(../../assets/img//h2.gif);
}
td.TopDarkNav {
  background-image: url(../../assets/img//h12.gif);
}

.td_hr_down {
  border-bottom-width: 4px;
  border-top-style: none;
  border-bottom-style: solid;
  border-bottom-color: #6cb734;
}
td.td_hr_up {
  border-top-width: 1px;
  border-top-style: dashed;
  border-top-color: #6cb734;
}
.trtitle {
  background-color: #18b832;
  color: #ffffff;
  background-position: center;
  height: 30px;
}

.shen {
  background-color: #f0f0f0;
}
.table_blue {
  border: 1px solid #63a2e7;
  background-color: #ffffff;
}
td.TableTitle1 {
  color: #ffffff;
  background-color: #a9d46d;
}
td.TableTitle2 {
  background-color: #e3f1d1;
}
td.TableBody1 {
  background-color: #f4faed;
}
td.TableBody2 {
  background-color: #e3f1d1;
}
.PageInput {
  border-right: #d6e0ef 1px solid;
  border-top: #d6e0ef 1px solid;
  font-size: 11px;
  border-left: #d6e0ef 1px solid;
  border-bottom: #d6e0ef 1px solid;
  font-family: Arial;
  background-color: #fafafa;
}
.tableBorder5 {
  border-right: #a9d46d 1px solid;
  border-top: #a9d46d 1px solid;
  border-left: #a9d46d 1px solid;
  border-bottom: #a9d46d 1px solid;
  background-color: #d6e0ef;
}
.showhand {
  cursor: hand;
}
.Menu_popup {
  display: none;
}
.ImgOnclick {
  cursor: pointer;
}
.menuskin {
  border-right: #666666 1px solid;
  border-top: #666666 1px solid;
  background-image: url(../../assets/img/menubg.gif);
  visibility: hidden;
  font: 12px Verdana;
  border-left: #666666 1px solid;
  border-bottom: #666666 1px solid;
  background-repeat: repeat-y;
  position: absolute;
  background-color: #efefef;
}
.menuskin A {
  padding-right: 10px;
  padding-left: 25px;
  color: black;
  text-decoration: none;
}
#mouseoverstyle {
  border-right: #597db5 1px solid;
  padding-right: 0px;
  border-top: #597db5 1px solid;
  padding-left: 0px;
  padding-bottom: 0px;
  margin: 2px;
  border-left: #597db5 1px solid;
  padding-top: 0px;
  border-bottom: #597db5 1px solid;
  background-color: #c9d5e7;
}
#mouseoverstyle A {
  color: black;
}
.menuitems {
  padding-right: 1px;
  padding-left: 1px;
  padding-bottom: 1px;
  margin: 2px;
  word-break: keep-all;
  line-height: 14pt;
  padding-top: 1px;
  text-align: left;
}

.smallfont {
  font-size: 11px;
  color: #000000;
  font-family: Tahoma, Georgia;
}
.count {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: #cc6600;
}
.table_info_th {
  background-color: #18b832;
  color: #ffffff;
}
</style>